import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { firestoreCollections } from "../../utils/constantInformation";
import { connect } from "react-redux";
import { signoutRequest } from "../../redux/GameInformation/GameInformationAction";
import { deleteDocument } from "../../firestoreQueries";
import { isLoggedIn } from "../../utils/utils";
import AppJS from "../../assets/app/AppJS";
import AppCSS from "../../assets/app/AppCSS";

const DeleteAccount = (props) => {
  const [verificationText, setVerificationText] = useState("");
  const [isAccountDeleted, setAccountDeleted] = useState(false);
  const [error, setError] = useState(null);

  React.useEffect(async () => {
    const loginStatus = await checkLoginStatus();
    if (!loginStatus) {
      window.location.href = "/app/signin";
      props.reset_state();
    }
  }, []);

  const checkLoginStatus = async () => {
    try {
      const resp = await isLoggedIn("requestAccountDeletion");
      console.log("isLoggedIn requestAccountDeletion:: " + resp);
      return resp === true;
    } catch (error) {
      console.log("requestAccountDeletion Component::: Not Logged in");
    }
  };

  const handleVerificationChange = (event) => {
    setVerificationText(event.target.value);
  };

  const handleCopy = (event) => {
    event.preventDefault();
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  const handleDeleteAccount = () => {
    console.log("handleDeleteAccount - Called");
    if (verificationText !== "delete") {
      setError("Please enter 'delete' to confirm account deletion.");
      return;
    }

    const user = auth.currentUser;

    console.log("handleDeleteAccount - Got User");
    if (user) {
      const userId = user.uid;
      console.log("handleDeleteAccount -- userID: ", userId);
      const batch = db.batch();
      const deletePromises = [];
      console.log(
        "handleDeleteAccount - firestoreCollections:",
        firestoreCollections
      );

      firestoreCollections.forEach((collection) => {
        const query = db.collection(collection).where("userID", "==", userId);
        const deletePromise = query.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log("Delete Doc:: ", doc.ref);
            deleteDocument(doc);
          });
        });
        deletePromises.push(deletePromise);
      });

      console.log("handleDeleteAccount - pushed all promises");
      console.log(
        "handleDeleteAccount - pushed all promises",
        deletePromises.length
      );

      Promise.all(deletePromises)
        .then(() => {
          // All delete operations completed successfully
          console.log("Firestore Data Deleted!");
          // Return a promise that resolves when user.delete() is completed
          return user.delete();
        })
        .then(() => {
          // Account deletion successful
          setAccountDeleted(true);
          props.reset_state();
        })
        .catch((error) => {
          // Error occurred while querying, deleting documents, or deleting the account
          console.log(
            "handleDeleteAccount - Firestore Data Deletion Error:",
            error
          );
          setError(error.message);
        });
    } else {
      props.reset_state();
      window.location.href("/app/signin");
    }
    console.log("handleDeleteAccount - Done");
  };

  return (
    <>
      <AppJS />
      <AppCSS />
      <div className="d-flex flex-column vh-100 justify-content-between">
        <div className="d-flex justify-content-start p-4 align-items-center mt-5">
          {!isAccountDeleted ? (
            <div className="text-white">
              <h1 className="font-style-bold">Confirm Account Deletion</h1>
              <p className="lead">
                We deeply regret your departure from our platform. Upon deleting
                your account, all of your data, including your profile, lineups,
                and locked/excluded players, will be permanently removed. We
                understand the gravity of this decision and its implications. If
                you have any inquiries or need further assistance, please don't
                hesitate to contact us at{" "}
                <span className="font-weight-bold">
                  <mark>spontasy@sportsseam.com</mark>
                </span>
              </p>
              <p className="lead">To confirm deletion, type "delete" below</p>

              <input
                className="form-control m-1"
                type="text"
                value={verificationText}
                onChange={handleVerificationChange}
                onCopy={handleCopy}
                onPaste={handlePaste}
              />

              <button
                className="btn btn-lg btn-danger m-1"
                onClick={handleDeleteAccount}
              >
                Delete My Account
              </button>
              {error && <p>Error: {error}</p>}
            </div>
          ) : (
            <div>
              <h1>Confirm Account Deletion</h1>
              <p>Your account has been successfully deleted.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    game_information_info: state,
    state_in_memory_timeframe: state.gameInformationReducer.in_memory_timeframe,
    state_horizontal_scroll_position:
      state.gameInformationReducer.horizontal_scroll_position,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset_state: () => dispatch(signoutRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
